var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-key (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Algo---Legs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Algo-1---Choose-Legs---State-1",
    transform: "translate(-1183.000000, -25.000000)",
    fill: "#F35555",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-key-(1)",
    transform: "translate(1183.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04166667,0 C6.3035,0 4.08333333,2.22016667 4.08333333,4.95833333 C4.08333333,5.56633817 4.19862917,6.146119 4.398926,6.68440733 L0,11.0833333 L0,14 L2.91666667,14 L2.91666667,12.25 L4.66666667,12.25 L4.66666667,10.5 L6.41666667,10.5 L7.31559267,9.601074 C7.853881,9.80137083 8.43366183,9.91666667 9.04166667,9.91666667 C11.7798333,9.91666667 14,7.6965 14,4.95833333 C14,2.22016667 11.7798333,0 9.04166667,0 Z M10.2083333,2.33333333 C11.0139167,2.33333333 11.6666667,2.98608333 11.6666667,3.79166667 C11.6666667,4.59725 11.0139167,5.25 10.2083333,5.25 C9.40275,5.25 8.75,4.59725 8.75,3.79166667 C8.75,2.98608333 9.40275,2.33333333 10.2083333,2.33333333 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.5bb6d5cbec867584986c076465bc7861.svg";
export { ForwardRef as ReactComponent };